import { render, staticRenderFns } from "./attachment-info.html?vue&type=template&id=d7442d92&scoped=true&external"
import script from "./attachment-info.js?vue&type=script&lang=js&external"
export * from "./attachment-info.js?vue&type=script&lang=js&external"
import style0 from "./attachment-info.scss?vue&type=style&index=0&id=d7442d92&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7442d92",
  null
  
)

export default component.exports